const RestrictedChannels = ({ channel }) => {
  switch (channel) {
    case 1:
      return <span className="badge text-dark bg-success">Amazon</span>;
    case 2:
      return <span className="badge text-dark bg-primary">Walmart</span>;
    case 3:
      return (
        <div className="d-flex flex-wrap gap-1 justify-content-space-between">
          <span className="badge text-dark bg-success">Amazon</span>
          <span className="badge text-dark bg-primary">Walmart</span>
        </div>
      );
    case 4:
      return <span className="badge text-dark bg-danger">eBay</span>;
    case 5:
      return (
        <div className="d-flex flex-wrap gap-1 justify-content-space-between">
          <span className="badge text-dark bg-success">Amazon</span>
          <span className="badge text-dark bg-primary">Walmart</span>
          <span className="badge text-dark bg-danger">eBay</span>
        </div>
      );
    case 6:
      return (
        <div className="d-flex flex-wrap gap-1 justify-content-space-between">
          <span className="badge text-dark bg-danger">eBay</span>
          <span className="badge text-dark bg-primary">Walmart</span>
        </div>
      );
    case 7:
      return (
        <div className="d-flex flex-wrap gap-1 justify-content-space-between">
          <span className="badge text-dark bg-success">Amazon</span>
          <span className="badge text-dark bg-primary">Walmart</span>
          <span className="badge text-dark bg-danger">eBay</span>
        </div>
      );
    case 8:
      return <span className="badge text-dark bg-warning">Other</span>;
    case 9:
      return (
        <div className="d-flex flex-wrap gap-1 justify-content-space-between">
          <span className="badge text-dark bg-warning">Other</span>
          <span className="badge text-dark bg-success">Amazon</span>
        </div>
      );
    case 10:
      return (
        <div className="d-flex flex-wrap gap-1 justify-content-space-between">
          <span className="badge text-dark bg-warning">Other</span>
          <span className="badge text-dark bg-primary">Walmart</span>
        </div>
      );
    case 11:
      return (
        <div className="d-flex flex-wrap gap-1 justify-content-space-between">
          <span className="badge text-dark bg-warning">Other</span>
          <span className="badge text-dark bg-success">Amazon</span>
          <span className="badge text-dark bg-primary">Walmart</span>
        </div>
      );
    case 12:
      return (
        <div className="d-flex flex-wrap gap-1 justify-content-space-between">
          <span className="badge text-dark bg-warning">Other</span>
          <span className="badge text-dark bg-danger">eBay</span>
        </div>
      );
    case 13:
      return (
        <div className="d-flex flex-wrap gap-1 justify-content-space-between">
          <span className="badge text-dark bg-warning">Other</span>
          <span className="badge text-dark bg-success">Amazon</span>
          <span className="badge text-dark bg-danger">eBay</span>
        </div>
      );
    case 14:
      return (
        <div className="d-flex flex-wrap gap-1 justify-content-space-between">
          <span className="badge text-dark bg-warning">Other</span>
          <span className="badge text-dark bg-primary">Walmart</span>
          <span className="badge text-dark bg-danger">eBay</span>
        </div>
      );
    case 15:
      return (
        <div className="d-flex flex-wrap gap-1 justify-content-space-between">
          <span className="badge text-dark bg-warning">Other</span>
          <span className="badge text-dark bg-success">Amazon</span>
          <span className="badge text-dark bg-primary">Walmart</span>
          <span className="badge text-dark bg-danger">eBay</span>
        </div>
      );
    default:
      return <span className="badge text-dark bg-info">none</span>;
  }
};

export default RestrictedChannels;
